export const productSettings = {
    productName: process.env.REACT_APP_PRODUCT_NAME ?? "Land Acquisition"
};